import { useEffect, useState } from "react";
import { API, CONTACT } from "@/assets";

let cache = null;

export const useContent = () => {
  const [content, setContent] = useState(cache || {});
  useEffect(() => {
    if (cache) {
      setContent(cache);
      return;
    }
    fetch(`${API}/content`)
      .then((r) => r.json())
      .then((d) => {
        cache = d.content || {};
        setContent(cache);
      })
      .catch(() => {});
  }, []);
  return content;
};

// Visitor-facing contact details, editable in Label Ops → Site Text.
export const useContact = () => {
  const content = useContent();
  const phones = content.contact_phones
    ? content.contact_phones.split(/\n+/).map((p) => p.trim()).filter(Boolean)
    : CONTACT.phones;
  return {
    email: content.contact_email || CONTACT.email,
    support: content.support_email || CONTACT.support,
    press: content.press_email || "media.press@cold-blooded-records.com",
    phones: phones.length ? phones : CONTACT.phones,
    address: content.mailing_address || "PO Box 1074, Clearwater, SC 29822",
  };
};
